import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=0d19854e"
import script from "./forget-password.vue?vue&type=script&lang=js"
export * from "./forget-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d19854e')) {
      api.createRecord('0d19854e', component.options)
    } else {
      api.reload('0d19854e', component.options)
    }
    module.hot.accept("./forget-password.vue?vue&type=template&id=0d19854e", function () {
      api.rerender('0d19854e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/forget-password.vue"
export default component.exports